import React from "react";
import formatDate from "helpers/formatDate";

const DaySeparator = ({ date }: { date: string }) => (
  <section className="chat__seperator text-center border-b border-dashed border-neutral text-muted h-3 text-sm mb-5 mt-2">
    <span className="px-2 bg-white">
      {date && formatDate(new Date(date), "dd.MM.y")}
    </span>
  </section>
);

export default DaySeparator;
